import styled from 'styled-components';
import { media } from 'helpers/breakpoints';
import { InfoTitle } from 'components/Toolkit/InfoTitle/InfoTitle';

const FeaturesContainer = styled.div`
  display: grid;
  column-gap: ${({ theme }) => theme.spacing.M16};
  row-gap: ${({ theme }) => theme.spacing.M16};
  margin-top: ${({ theme }) => theme.spacing.S8};

  ${media.large} {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const Header = styled(InfoTitle)`
  padding: 0 0 ${({ theme }) => theme.spacing.M16} 0;
`;

const KeyInfoWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing.S8};
`;

export { FeaturesContainer, Header, KeyInfoWrapper };
